export const ContextTypes = {
  ACH_OUT: 'ACH_OUT',
  BILL_PAY: 'BILL_PAY',
  INVITE_ACCOUNTANT: 'INVITE_ACCOUNTANT',
};
